<script lang="ts" module>
</script>

<script lang="ts" generics="T extends unknown">
  import { Button, type ButtonProps } from '@athena-lib/Button';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import Spinner from '@athena-lib/Icons/Spinner.svelte';
  import { Popover } from '@athena-lib/Popover';
  import Error from '@athena-lib/Icons/Error.svelte';
  import { useMutation } from '@athena-lib/useMutation.svelte';

  const {
    createPromise,
    children,
    ...buttonProps
  }: ButtonProps & { createPromise: () => Promise<T> } = $props();
  const { state, mutate } = useMutation(() => createPromise(), { clearAfterMs: 5000 });
  const translations = getCommonTranslations();
  const iconClass = $derived.by((): string => {
    switch (buttonProps.size) {
      case 'small':
        return 'h-4 w-4 mx-auto';
      case 'medium':
        return 'h-3 w-3 mx-auto';
      default:
        return 'h-5 w-5 mx-auto';
    }
  });
</script>

<Button
  {...buttonProps}
  disabled={buttonProps.disabled || state.type === 'loading'}
  onClick={(e) => {
    mutate();
    buttonProps.onClick?.(e);
  }}
>
  {#if state.type === 'loading'}
    <Spinner sizeClass={iconClass} />
  {:else if state.type === 'rejected'}
    <Popover placement="bottom-end" class="inline">
      {#snippet floater()}
        <div class="inline-block rounded bg-st-black px-2 py-1 text-st-yellow">
          {translations.anErrorHasOccured}
        </div>
      {/snippet}
      <Error sizeClass={iconClass} />
    </Popover>
  {:else if state.type === 'resolved'}
    {@render children()}
  {:else if state.type === 'initial'}
    {@render children()}
  {/if}
</Button>
